<div class="row">
  <div class="col-12">
    <h5 class="text-success">
      <ng-icon name="lucideSquare" class="me-2"></ng-icon>
      {{ myUpcomingWorkshopListLabel }}
    </h5>
  </div>

  <dx-tab-panel [swipeEnabled]="false">
    <dxi-item
      *ngFor="let group of workshopsByMonth | async"
      [title]="group.title"
    >
      <div class="col-12 mt-4" *ngIf="group.workshops.length === 0">
        <div class="alert alert-light">
          <div class="text-bold text-center">
            فهرست کارگاه‌های پیش‌روی شما خالی است.
          </div>
          <div class="my-3 text-center">
            برای مشاهده و ثبت‌نام در کارگاه‌های آموزشی روی دکمه زیر کلیک کنید.
          </div>
          <div class="mt-3 text-center">
            <button class="btn btn-success" routerLink="/workshop/workshops">
              فهرست کارگاه‌های آموزشی
            </button>
          </div>
          <div
            class="text-center mt-4 d-flex flex-sm-row flex-column justify-content-center"
          >
            <span>
              <a
                href="https://afraway.org/ws"
                target="_blank"
                class="link-success"
                >راهنمای ثبت نام در کارگاه ها</a
              >
            </span>
            <span class="mx-sm-2 d-none d-sm-inline">|</span>
            <div>
              شماره تماس:
              <span class="ms-1"
                ><a class="link-success" href="tel:02191002372">02191002372</a>
              </span>
              <span class="ms-2">داخلی ۱</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-3">
        <div
          *ngFor="let workshop of group.workshops"
          class="col-12 col-lg-4 col-md-6 mb-2"
          height="250px"
        >
          <app-workshop-card
            [workshop]="workshop"
            [isRegisteredAndPending]="
              pendingWorkshopRegisteredIds.includes(workshop.id)
            "
            [isRegisteredAndApproved]="
              approvedWorkshopRegisteredIds.includes(workshop.id)
            "
            [isRegisteredAndRejected]="
              rejectedWorkshopRegisteredIds.includes(workshop.id)
            "
            [canRegister]="!workshopRegisteredIds.includes(workshop.id)"
            (onRegister)="onRegister($event)"
          >
          </app-workshop-card>
        </div>
      </div>
    </dxi-item>
  </dx-tab-panel>

  <app-workshop-register
    *ngIf="showRegisterPopup"
    [workshopId]="selectedWorkshopId"
    (onHideWorkshopRegisteringPopup)="onWorkshopRegisteringPopupHide()"
  ></app-workshop-register>
</div>
